import { CSSProperties, PropsWithChildren } from 'react';
import { Transition } from 'react-transition-group';
import styled from 'styled-components';

const duration = 180;
const transitionName = 'slide';

type Direction = 'left' | 'right';
type StylableComponent = { style?: CSSProperties };

const SlideInTransition = styled.div<{ direction?: Direction }>`
  transition: transform ${duration}ms ease-in-out;
  transform: translateX(${props => (props.direction === 'left' ? '-101%' : '101%')});
  height: 100%;

  &.${transitionName}-entering {
    transform: translateX(${props => (props.direction === 'left' ? '-101%' : '101%')});
  }

  &.${transitionName}-entered {
    transform: translateX(0%);
  }

  &.${transitionName}-exiting {
    display: none;
  }

  &.${transitionName}-exited {
    display: none;
  }
`;

interface Props extends StylableComponent {
  isOpen: boolean;
  direction?: Direction;
}

export function SlideIn({ children, isOpen, style, direction = 'left' }: PropsWithChildren<Props>) {
  return (
    <Transition in={isOpen} timeout={duration} classNames={transitionName}>
      {state => (
        <SlideInTransition style={style} className={`${transitionName}-${state}`} direction={direction}>
          {children}
        </SlideInTransition>
      )}
    </Transition>
  );
}
